require('../bootstrap');
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import DingHelper from '../plugins/helper';
import BootstrapVue from 'bootstrap-vue'
import localization from '../localization';
import swal from 'vue-sweetalert';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';
import { Swiper, Navigation as SwiperNavigation } from 'vue-awesome-swiper';
import '../mixins/string-utils';
import { GATracker } from '../bu/models/GA4';

import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'

Swiper.use([SwiperNavigation]);

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(DingHelper);
Vue.use(BootstrapVue);
Vue.use(swal);
Vue.use(VueClipboard)

window.Vue = Vue;
window.VueI18n = VueI18n;
window.localization = localization;
window.tracker = new GATracker();

Vue.component('landing-container', require('../components/landing/LandingContainer.vue').default);
Vue.component('new-landing-container', require('../components/landing/NewLandingContainer.vue').default);
Vue.component('editable-text', require('../components/EditableText.vue').default);
Vue.component('content-unit', require('../components/ContentUnit.vue').default);
Vue.component('login-box', require('../components/LoginBox.vue').default);
Vue.component('customer-my-box', require('../components/CustomerMyBox.vue').default);
Vue.component('customer-bookings', require('../components/CustomerBookings.vue').default);
Vue.component('login-box-sms-verification', require('../components/common/LoginBoxSMSVerification.vue').default);

Vue.component('time-checking-component', require('../components/landing/TimeCheckingComponent.vue').default);
Vue.component('block-hero', require('../components/landing/BlockHero.vue').default);
Vue.component('block-address', require('../components/landing/BlockAddress.vue').default);
Vue.component('block-text-and-image', require('../components/landing/BlockTextAndImage.vue').default);
Vue.component('block-portfolio', require('../components/landing/BlockPortfolio.vue').default);
Vue.component('display-album', require('../components/landing/DisplayAlbum.vue').default);
Vue.component('block-user-review', require('../components/landing/BlockUserReview.vue').default);
Vue.component('block-bookable', require('../components/landing/BlockBookable.vue').default);
Vue.component('block-services', require('../components/landing/BlockServices.vue').default);
Vue.component('block-members', require('../components/landing/BlockMembers.vue').default);
Vue.component('block-youtube', require('../components/landing/BlockYoutube.vue').default);
Vue.component('block-provider-recommendation', require('../components/landing/BlockProviderRecommendation.vue').default);
Vue.component('user-review-entry', require('../components/UserReviewEntry.vue').default);

Vue.component('block-text', require('../components/landing/BlockText.vue').default);
Vue.component('expandable-text', require('../components/ExpandableText.vue').default);
Vue.component('customer-booking-checker', require('../components/landing/CustomerBookingChecker').default);
Vue.component('block-ig', require('../components/landing/BlockIG.vue').default);

Vue.component('item-viewer', require('../components/ItemViewer.vue').default);
Vue.component('shopping-browser', require('../components/ShoppingBrowser.vue').default);
Vue.component('customer-information-form', require('../components/booking/CustomerInformationForm.vue').default);
Vue.component('printable-bookings', require('../components/booking/PrintableBookings.vue').default);
Vue.component('booking-form', require('../components/booking/BookingForm.vue').default);
Vue.component('new-booking-form', require('../components/booking/NewBookingForm.vue').default);
Vue.component('question-choice', require('../components/booking/QuestionChoice.vue').default);
Vue.component('question-multiple-choice-with-note', require('../components/booking/QuestionMultipleChoiceWithNote.vue').default);
Vue.component('question-text', require('../components/booking/QuestionText.vue').default);
Vue.component('question-info', require('../components/booking/QuestionInfo.vue').default);
Vue.component('question-shopping', require('../components/booking/QuestionShopping.vue').default);
Vue.component('question-file-upload', require('../components/booking/QuestionFileUpload.vue').default);
Vue.component('question-date', require('../components/booking/QuestionDate.vue').default);
Vue.component('question-linear-scale', require('../components/booking/QuestionLinearScale.vue').default);
Vue.component('question-section', require('../components/booking/QuestionSection.vue').default);
Vue.component('question-address', require('../components/booking/QuestionAddress.vue').default);
Vue.component('question-youtube', require('../components/booking/QuestionYoutube.vue').default);
Vue.component('question-matrix', require('../components/booking/QuestionMatrix.vue').default);
Vue.component('option-content-unit', require('../components/OptionContentUnit.vue').default);
Vue.component('sms-verification-popup', require('../components/common/SMSVerificationPopup.vue').default);
Vue.component('modal', require('../components/common/Modal.vue').default);
Vue.component('sms-rate-modal', require('../components/sms/SMSRateModal').default);
Vue.component('cart', require('../components/Cart.vue').default);
Vue.component('item-count-control', require('../components/ItemCountControl.vue').default);
